module.exports = __webpack_public_path__ + "static/img/compare.cb7a2f6c.svg";